import { Link } from "@tanstack/react-router";
import { cn } from "tailwind-variants";
import type { AnimationScrollType } from "#/_packages/umbrella/types";
import { getAltTextFromString } from "#/_packages/umbrella/utils/image-utils.ts";

export type LogoProps = {
	href: string;
	ariaLabel?: string;
	text?: string;
	imageSrc?: string;
	imageAlt?: string;
	animationScrollType?: AnimationScrollType;
	hoverItemClasses?: string | null;
	hoverMediaClasses?: string | null;
	isDrawer?: boolean;
	className?: string;
};

export function Logo({
	href,
	ariaLabel,
	text,
	imageSrc,
	imageAlt,
	animationScrollType = "none",
	hoverItemClasses,
	hoverMediaClasses,
	className,
}: LogoProps) {
	const resolvedAlt =
		getAltTextFromString(text) || getAltTextFromString(imageAlt);

	return (
		<Link
			to={"/$"}
			params={{ _splat: href }}
			aria-label={ariaLabel}
			className={cn(
				"block__logo site-logo-lockup",
				hoverItemClasses,
				animationScrollType !== "none" && animationScrollType,
				className,
			)}
		>
			{imageSrc ? (
				<img
					src={imageSrc}
					alt={resolvedAlt}
					className={cn("site-logo-brandmark", hoverMediaClasses)}
					loading="lazy"
				/>
			) : text ? (
				<div className="site-logo-wordmark notranslate">{text}</div>
			) : null}
		</Link>
	);
}
